export default import.meta.ROLLDOWN_FILE_URL_Njtx_z86JRue_R_B55fIbA